export default __webpack_public_path__ + "static/media/folder.889809dc.png";